/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';


/**
 * Internal Item Model Controller
 */
@Injectable({
  providedIn: 'root',
})
class InternalItemModelControllerService extends __BaseService {
  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `InternalItemModelControllerService.IndexItemUsingPOSTParams` containing the following parameters:
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * - `filePath`: filePath
   *
   * @return OK
   */
  indexItemUsingPOSTResponse(params: InternalItemModelControllerService.IndexItemUsingPOSTParams): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.revisionTag != null) __params = __params.set('revisionTag', params.revisionTag.toString());
    if (params.filePath != null) __params = __params.set('filePath', params.filePath.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/headless/item/index/${params.collectionTypeName}/**`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({ body: (_r as HttpResponse<any>).body === 'true' }) as __StrictHttpResponse<boolean>
      })
    );
  }
  /**
   * @param params The `InternalItemModelControllerService.IndexItemUsingPOSTParams` containing the following parameters:
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * - `filePath`: filePath
   *
   * @return OK
   */
  indexItemUsingPOST(params: InternalItemModelControllerService.IndexItemUsingPOSTParams): __Observable<boolean> {
    return this.indexItemUsingPOSTResponse(params).pipe(
      __map(_r => _r.body as boolean)
    );
  }

  /**
   * @param params The `InternalItemModelControllerService.DeleteItemUsingDELETEParams` containing the following parameters:
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * - `filePath`: filePath
   */
  deleteItemUsingDELETEResponse(params: InternalItemModelControllerService.DeleteItemUsingDELETEParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.revisionTag != null) __params = __params.set('revisionTag', params.revisionTag.toString());
    if (params.filePath != null) __params = __params.set('filePath', params.filePath.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/headless/item/index/${params.collectionTypeName}/**`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `InternalItemModelControllerService.DeleteItemUsingDELETEParams` containing the following parameters:
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * - `filePath`: filePath
   */
  deleteItemUsingDELETE(params: InternalItemModelControllerService.DeleteItemUsingDELETEParams): __Observable<null> {
    return this.deleteItemUsingDELETEResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `InternalItemModelControllerService.GetJsonUsingGETParams` containing the following parameters:
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * - `filePath`: filePath
   *
   * @return OK
   */
  getJsonUsingGETResponse(params: InternalItemModelControllerService.GetJsonUsingGETParams): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.revisionTag != null) __params = __params.set('revisionTag', params.revisionTag.toString());
    if (params.filePath != null) __params = __params.set('filePath', params.filePath.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/headless/item/preview/${params.collectionTypeName}/**`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * @param params The `InternalItemModelControllerService.GetJsonUsingGETParams` containing the following parameters:
   *
   * - `collectionTypeName`: collectionTypeName
   *
   * - `revisionTag`: revisionTag
   *
   * - `filePath`: filePath
   *
   * @return OK
   */
  getJsonUsingGET(params: InternalItemModelControllerService.GetJsonUsingGETParams): __Observable<{}> {
    return this.getJsonUsingGETResponse(params).pipe(
      __map(_r => _r.body as {})
    );
  }
}

module InternalItemModelControllerService {

  /**
   * Parameters for indexItemUsingPOST
   */
  export interface IndexItemUsingPOSTParams {

    /**
     * collectionTypeName
     */
    collectionTypeName: string;

    /**
     * revisionTag
     */
    revisionTag?: string;

    /**
     * filePath
     */
    filePath?: string;
  }

  /**
   * Parameters for deleteItemUsingDELETE
   */
  export interface DeleteItemUsingDELETEParams {

    /**
     * collectionTypeName
     */
    collectionTypeName: string;

    /**
     * revisionTag
     */
    revisionTag?: string;

    /**
     * filePath
     */
    filePath?: string;
  }

  /**
   * Parameters for getJsonUsingGET
   */
  export interface GetJsonUsingGETParams {

    /**
     * collectionTypeName
     */
    collectionTypeName: string;

    /**
     * revisionTag
     */
    revisionTag?: string;

    /**
     * filePath
     */
    filePath?: string;
  }
}

export { InternalItemModelControllerService }
